import { createAction } from 'redux-actions';
import { bindRoutineToReduxForm, createRoutine } from 'redux-saga-routines';

import {
  VIDEO_CONSOLE,
  SET_LOCATION,
  SET_DATE,
  SEARCH_LOCATION_STATION,
  SET_EXERCISE_REST,
} from './types';

export const videoConsole = createRoutine(VIDEO_CONSOLE);
export const searchLocationStation = createRoutine(SEARCH_LOCATION_STATION);

export const setLocation = createAction(SET_LOCATION);
export const setLocationStationDate = createAction(SET_DATE);
export const setExerciseRest = createAction(SET_EXERCISE_REST);

export const bindedVideoConsole = bindRoutineToReduxForm(videoConsole);
